import { combineReducers } from '@reduxjs/toolkit';
import updatePagesReducer from './update/updateSlice';
import pageListReducer from './list/listSlice';

const pagesSlice = combineReducers({
    update: updatePagesReducer,
    list: pageListReducer,
});

export default pagesSlice;
